export const USERS = "/profiles"
export const USER = "/profile/:param"
export const REGENRATE_PASSWORD = "profiles/:param/generate-password"
